/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateReservationDto } from '../models/work-create-reservation-dto';
import { WorkFindFreeTimeslotsDto } from '../models/work-find-free-timeslots-dto';
import { WorkReservationConfirmGoogleCalendarEventDto } from '../models/work-reservation-confirm-google-calendar-event-dto';
import { WorkReservationTimeslotsDto } from '../models/work-reservation-timeslots-dto';
import { WorkSendReservationFeedbackDto } from '../models/work-send-reservation-feedback-dto';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateReservationDto } from '../models/work-update-reservation-dto';
import { WorkVerifyReservationOtpDto } from '../models/work-verify-reservation-otp-dto';

@Injectable({ providedIn: 'root' })
export class WorkReservationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reservationsV1ControllerFindFreeTimeslots()` */
  static readonly ReservationsV1ControllerFindFreeTimeslotsPath = '/v1/reservations/findFreeTimeslots';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationsV1ControllerFindFreeTimeslots()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV1ControllerFindFreeTimeslots$Response(
    params: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkFindFreeTimeslotsDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkReservationTimeslotsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationsService.ReservationsV1ControllerFindFreeTimeslotsPath, 'post');
    if (params) {
      rb.header('x-api-key', params['x-api-key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkReservationTimeslotsDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationsV1ControllerFindFreeTimeslots$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV1ControllerFindFreeTimeslots(
    params: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkFindFreeTimeslotsDto
    },
    context?: HttpContext
  ): Observable<WorkReservationTimeslotsDto> {
    return this.reservationsV1ControllerFindFreeTimeslots$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkReservationTimeslotsDto>): WorkReservationTimeslotsDto => r.body)
    );
  }

  /** Path part for operation `reservationsV1ControllerCreate()` */
  static readonly ReservationsV1ControllerCreatePath = '/v1/reservations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationsV1ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV1ControllerCreate$Response(
    params: {
      apiAppointmentSchedulerKey?: string;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkCreateReservationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationsService.ReservationsV1ControllerCreatePath, 'post');
    if (params) {
      rb.query('apiAppointmentSchedulerKey', params.apiAppointmentSchedulerKey, {});
      rb.header('x-api-key', params['x-api-key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationsV1ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV1ControllerCreate(
    params: {
      apiAppointmentSchedulerKey?: string;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkCreateReservationDto
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.reservationsV1ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `reservationsV1ControllerRemove()` */
  static readonly ReservationsV1ControllerRemovePath = '/v1/reservations/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationsV1ControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationsV1ControllerRemove$Response(
    params: {
      id: number;
      accessKey: string;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationsService.ReservationsV1ControllerRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('accessKey', params.accessKey, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationsV1ControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationsV1ControllerRemove(
    params: {
      id: number;
      accessKey: string;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.reservationsV1ControllerRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reservationsV1ControllerUpdate()` */
  static readonly ReservationsV1ControllerUpdatePath = '/v1/reservations/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationsV1ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV1ControllerUpdate$Response(
    params: {
      id: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkUpdateReservationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationsService.ReservationsV1ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('x-api-key', params['x-api-key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationsV1ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV1ControllerUpdate(
    params: {
      id: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkUpdateReservationDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.reservationsV1ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `reservationsV1ControllerConfirmGoogleCalendarEventForId()` */
  static readonly ReservationsV1ControllerConfirmGoogleCalendarEventForIdPath = '/v1/reservations/confirmGoogleCalendarEventForId/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationsV1ControllerConfirmGoogleCalendarEventForId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV1ControllerConfirmGoogleCalendarEventForId$Response(
    params: {
      id: number;
      body: WorkReservationConfirmGoogleCalendarEventDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationsService.ReservationsV1ControllerConfirmGoogleCalendarEventForIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationsV1ControllerConfirmGoogleCalendarEventForId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV1ControllerConfirmGoogleCalendarEventForId(
    params: {
      id: number;
      body: WorkReservationConfirmGoogleCalendarEventDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.reservationsV1ControllerConfirmGoogleCalendarEventForId$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `reservationsV1ControllerVerifyOtp()` */
  static readonly ReservationsV1ControllerVerifyOtpPath = '/v1/reservations/verifyOtp';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationsV1ControllerVerifyOtp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV1ControllerVerifyOtp$Response(
    params: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkVerifyReservationOtpDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationsService.ReservationsV1ControllerVerifyOtpPath, 'post');
    if (params) {
      rb.header('x-api-key', params['x-api-key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationsV1ControllerVerifyOtp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV1ControllerVerifyOtp(
    params: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: WorkVerifyReservationOtpDto
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.reservationsV1ControllerVerifyOtp$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `reservationsV1ControllerSendFeedback()` */
  static readonly ReservationsV1ControllerSendFeedbackPath = '/v1/reservations/sendFeedback';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationsV1ControllerSendFeedback()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV1ControllerSendFeedback$Response(
    params: {
      body: WorkSendReservationFeedbackDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationsService.ReservationsV1ControllerSendFeedbackPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationsV1ControllerSendFeedback$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationsV1ControllerSendFeedback(
    params: {
      body: WorkSendReservationFeedbackDto
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.reservationsV1ControllerSendFeedback$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
